import { NAV_SECTIONS } from '../navigation/navConfig';
import type { HelpAreaId } from './types';

export interface HelpArea {
  id: HelpAreaId;
  label: string;
  /** Bootstrap icon, the same as the section's rail icon. */
  icon: string;
}

/**
 * The help areas, in the order the navigation rail lists its sections, after Getting Started.
 * The labels are the rail's own, so the help list and the menu name things the same way. A facility
 * that renames Residents still sees "Residents" here: help is written for every facility.
 */
export const HELP_AREAS: HelpArea[] = [
  { id: 'general', label: 'Getting Started', icon: 'bi-signpost-2' },
  ...NAV_SECTIONS.map((s) => ({ id: s.id as HelpAreaId, label: s.label, icon: s.icon })),
];

export function helpArea(id: string | null | undefined): HelpArea | undefined {
  return HELP_AREAS.find((a) => a.id === id);
}
